export default __webpack_public_path__ + "static/media/wonderwoman.aba0154d.png";